import PropTypes from 'prop-types';

import { startAdvertisingSignup } from '@sm/advertising';
import { getFlagsById } from '@sm/Flags';
import LinkButton from './LinkButton';

function AccountCardLinks(props) {
  const {
    SCEmailAddressApproved,
    sellerId,
    linkedPPC,
    marketplaces,
    mainMarketplace,
    linkedSPA,
    onConnectSPA,
    onApproveEmail,
    setNotificationMsg,
    notConnectedEndpoints,
    spApiConnectionExpired
  } = props;
  const mkList = marketplaces.filter(mk => mk !== 0);
  let region = null;
  if (mkList.length > 0) {
    const flagInfo = getFlagsById(mkList[0]);
    if (flagInfo) {
      region = flagInfo.regionName;
    }
  }

  const getLinkButtonTooltipText = () => {
    if (spApiConnectionExpired) {
      return 'Access token rotation is required to continue importing data from Amazon. Click to re-link your Seller Central account.';
    }
    return 'Enables product data and order data to be imported from Amazon to your Seller Metrix dashboard';
  };

  const linkList = [
    {
      btnText: `${
        notConnectedEndpoints || spApiConnectionExpired ? 'Relink' : 'Link'
      } Seller Central Account`,
      disabled: linkedSPA && !spApiConnectionExpired,
      onClick: () => onConnectSPA(mainMarketplace),
      tooltipText: getLinkButtonTooltipText(),
      notConnectedEndpoints,
      spApiConnectionExpired
    },
    {
      btnText: 'Link PPC Account',
      disabled: linkedPPC,
      onClick: () => {
        startAdvertisingSignup(
          sellerId,
          'handle_login_with_amazon/',
          errMsg => setNotificationMsg(errMsg),
          region
        );
      },
      tooltipText:
        'Enables Advertising data from Amazon to be imported to your Seller Metrix dashboard. Due to Amazon limits: Sponsored Products up to the last 90 days, other ad types up to the last 60 days.'
    },
    {
      disabled: SCEmailAddressApproved,
      alwaysAllow: true,
      btnText: 'Set Up Approved Sender',
      onClick: onApproveEmail,
      tooltipText:
        'To send Standard Emails to your customers, you need to add the Approved Sender Email Address to your Seller Central account. Click for more details...'
    }
  ];
  return (
    <div className="flex flex-col">
      {linkList
        .filter(item => !item.hidden)
        .map(link => (
          <LinkButton {...link} />
        ))}
    </div>
  );
}

AccountCardLinks.propTypes = {
  SCEmailAddressApproved: PropTypes.bool,
  linkedPPC: PropTypes.bool,
  linkedSPA: PropTypes.bool,
  sellerId: PropTypes.string.isRequired,
  onConnectSPA: PropTypes.func.isRequired,
  onApproveEmail: PropTypes.func.isRequired,
  setNotificationMsg: PropTypes.func.isRequired,
  marketplaces: PropTypes.instanceOf(Array).isRequired,
  notConnectedEndpoints: PropTypes.instanceOf(Array),
  mainMarketplace: PropTypes.number,
  spApiConnectionExpired: PropTypes.bool
};

AccountCardLinks.defaultProps = {
  SCEmailAddressApproved: false,
  linkedPPC: false,
  linkedSPA: false,
  mainMarketplace: null,
  notConnectedEndpoints: null,
  spApiConnectionExpired: false
};

export default AccountCardLinks;
